import React from "react";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../hooks/useStore";
import {useFetch} from "../../../hooks/useFetch";
import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {SelectField} from "./ZoneManagementSelect.style";

export const ZoneManagementSelect = ({
    value,
    onChange,
    disabled = false,
    mode = undefined,
    allowClear = false,
    showSearch = true,
    showTitle = true,
    showAllOption = false,
    marginBottom = "20px",
    placeholder = "",
    includeDeleted = false,
    optionFilter = () => true,
    initialCall = true,
    externalData = undefined,
    externalLoading = false,
    ...props
}) => {
    const {t} = useTranslation();
    const stores = useStore();

    const useExternalData = externalData !== undefined;

    const [internalLoading, internalData] = useFetch({
        defaultDataValue: {rows: []},
        fetchFn: stores.operationOrganizationStore.getZoneManagementList.bind(null, {
            paginate: false,
            includeDeleted
        }),
        dependencies: [includeDeleted],
        condition: !useExternalData,
        initialCall: useExternalData ? false : initialCall
    });

    const loading = useExternalData ? externalLoading : internalLoading;
    const zoneManagements = useExternalData ? externalData : internalData;

    return (
        <React.Fragment>
            {showTitle && <h5>{t("Bölge Müdürlüğü")}</h5>}
            <SelectField
                data-testid="zoneManagementSelect"
                value={value}
                onChange={onChange}
                disabled={disabled || loading}
                mode={mode}
                loading={loading}
                allowClear={allowClear}
                showSearch={showSearch}
                placeholder={placeholder || t("Bölge müdürlüğü seçiniz")}
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                mb={marginBottom}
                {...props}
            >
                {showAllOption && (
                    <SelectField.Option value="all" data-testid="zoneManagementSelect_all_option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                {zoneManagements?.data &&
                    zoneManagements.data.length > 0 &&
                    arrayAlphabeticalSort([...zoneManagements.data], "name")
                        .filter(optionFilter)
                        .map(zoneManagement => (
                            <SelectField.Option
                                key={zoneManagement._id}
                                value={zoneManagement._id}
                                data-testid="zoneManagementSelect_option"
                            >
                                {zoneManagement.name}
                            </SelectField.Option>
                        ))}
            </SelectField>
        </React.Fragment>
    );
};
